import React, { useEffect, useState } from 'react';

//styles
import styles from "./SearchModal.module.scss";


const SearchModal = ({ templateParameter, timeWaite }) => {

    const [keyShowSucc, setKeyShowSucc] = useState(false);


    const text1StartModal = templateParameter.text1StartModal ?? "";
    const textSuccStartModal = templateParameter.textSuccStartModal ?? "";
    const logoOrNotInStartModal = templateParameter.logoOrNotInStartModal ?? "";


    useEffect(() => {

        setTimeout(() => {

            setKeyShowSucc(true);

        }, +timeWaite * 1000);



    }, [])



    return (

        <div className={styles.startModalDiv}>

            <div className={styles.child}>


                {!keyShowSucc ?

                    <div className={styles.content}>

                        {logoOrNotInStartModal !== "1" &&

                            <img id={styles.logo} src="https://cdn.hamkadeh.com/up-files3/1692662458.png" alt="logohamkadeh" />
                        } 
                        

                        {text1StartModal !== "" && <span className={styles.textContent} dangerouslySetInnerHTML={{ __html: text1StartModal }}></span>}


                        <svg id={styles.searchIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C12.8487 19 14.551 18.3729 15.9056 17.3199L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L17.3199 15.9056C18.3729 14.551 19 12.8487 19 11C19 6.58172 15.4183 3 11 3ZM5 11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11Z"></path> </g></svg>



                    </div>


                    :

                    <div className={`${styles.content} ${styles.content2}`}>

                        <svg id={styles.sucIcon} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#03ac13" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"></path></g></svg>

                        {textSuccStartModal !== "" && <span className={styles.textContent} dangerouslySetInnerHTML={{ __html: textSuccStartModal }}></span>}


                        <span className={styles.loader}></span>

                    </div>
                }



            </div>



        </div>
    );
};

export default SearchModal;